import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';
import { Subscription } from 'rxjs';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-idex-dashboard',
  standalone: false,
  templateUrl: './idex-dashboard.component.html',
  styleUrl: './idex-dashboard.component.scss',
})
export class IdexDashboardComponent implements OnInit {
  proposals: Proposal[] = [];
  filteredProposals: Proposal[] = [];
  currentRole: string = 'doi';
  selectAll: boolean = false;

  stats = { total: 0, pending: 0, screening: 0, approved: 0 };

  filters = { category: '', status: '', priority: '', valuation: '' };
  // Proposal status tabs
  proposalStatusTabs = [
    { label: 'Work Done', status: 'initiated', active: false, tab: 1 }, // Show initiated proposals
    { label: 'Pending Work', status: 'in_review', active: false, tab: 1 }, // Show initiated proposals
  ];
  tableColumns = [
    { field: 'directorate', header: 'Directorate', filterType: 'text', filter: true },
    { field: 'name', header: 'Name', filterType: 'text', filter: true },
    { field: 'description', header: 'Description', filterType: 'text', filter: true },
    { field: 'steps', header: 'Steps', filterType: 'text' },
    { field: 'progress', header: 'Progress', filterType: 'text', filter: true },
    { field: 'proposal_status', header: 'Status', filterType: 'text', filter: true }
  ];
  tableColumnsPending = [
    { field: 'proposal_name', header: 'Proposal Name', filterType: 'text', filter: true },
    { field: 'scheme_name', header: 'Scheme Name', filterType: 'text', filter: true },
    { field: 'category', header: 'Category', filterType: 'text', filter: true },
    { field: 'type', header: 'Current step', filterType: 'text', filter: true },
    { field: 'created_by', header: 'Created by', filterType: 'text', filter: true }
  ];
  currentPage: number = 1;
  activeTabIndex: number = 0;
  activePhaseId: any;
  selectedPhaseId: any;
  lazy: boolean = true;
  totalCount = 10;
  filteredRecentProposals: any[];
  proposalData = [];
  phases = [];
  schemes: any;
  currentsubSchemeId: any;
  activeStatusTabIndex: any = this.proposalStatusTabs[0];

  // Modal control
  detailsModalOpen = false;
  selectedProposal: Proposal | null = null;
  userID: string;
  challengeForm: FormGroup;
  categoryOptions = [
    { label: 'To Move', value: 'To Move' },
    { label: 'To Fight', value: 'To Fight' },
    { label: 'To Float', value: 'To Float' },
  ];
  priorityOptions = [
    { label: 'High', value: 'High' },
    { label: 'Medium', value: 'Medium' },
    { label: 'Low', value: 'Low' },
  ];
  statusOptions = [
    { label: 'Launch', value: 'Launch' },
    { label: 'Duplicate', value: 'Duplicate' },
    { label: 'Reject', value: 'Reject' },
  ];
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  draftSotr: File;
  draftSotrFile: File | null = null;
  supportingDocsFiles: File | null = null;
  private subscriptions = new Subscription();
  @ViewChild('draftSotrUpload') draftSotrUpload!: FileUpload;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  PDSGenId: any;
  screening: any;
  apiUrl = environment.APIUrl;
  needGenData: any;
  needGenId;
  @Input() isEditable: boolean = false;
  routeForm: FormGroup;
  roleList: any;
  userList: any;
  userListCopy: any[];
  unitList: any;
  selectedChallenges: Proposal[];
  isEditMode = false;
  currentAction: 'view' | 'edit' = 'view';
  IRAremarks: string;
  fullscreenVisible = false;
  fullscreenChart: any = { type: '', data: {} };
  chartData1: any;
  chartOptions: any;
  /** Vertical canvas height for Proposal Trends (horizontal grouped bars need space per sub-scheme × series). */
  proposalTrendsChartHeightPx = 380;

  years: number[] = [];
  selectedYear: number = new Date().getFullYear();
  yearlyData: any[] = [];
  fromDate: any;
  toDate: any;

  // chartOptions: any = {
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   indexAxis: 'y',   // 👈 horizontal chart
  //   plugins: {
  //     legend: {
  //       position: 'top'
  //     }
  //   }
  // };

  //   // Chart Data
  //   chartData1 = {
  //     labels: ['2022', '2023', '2024'],
  //     datasets: [
  //       {
  //         label: 'Proposals Received',
  //         data: [120, 150, 180],
  //         backgroundColor: '#42A5F5',
  //       },
  //       { label: 'Completed', data: [90, 130, 160], backgroundColor: '#66BB6A' },
  //     ],
  //   };

  chartData2 = {
    labels: ['Idex', 'Adiiti', 'Prime', 'OC', 'Fauji'],
    datasets: [
      {
        label: 'Received',
        data: [50, 30, 40, 20, 25],
        backgroundColor: '#FFA726',
      },
      {
        label: 'In Progress',
        data: [20, 15, 10, 12, 8],
        backgroundColor: '#42A5F5',
      },
      {
        label: 'Completed',
        data: [25, 12, 20, 5, 15],
        backgroundColor: '#66BB6A',
      },
    ],
  };

  chartData3 = {
    labels: ['2022', '2023', '2024'],
    datasets: [
      {
        label: 'Funds Utilised (Cr)',
        data: [120, 180, 240],
        borderColor: '#42A5F5',
        fill: false,
        tension: 0.4,
      },
    ],
  };

  chartData4 = {
    labels: ['Proposal A', 'Proposal B', 'Proposal C', 'Proposal D'],
    datasets: [
      {
        data: [300, 150, 100, 80],
        backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726', '#AB47BC'],
      },
    ],
  };

  chartData5 = {
    labels: ['AI/ML', 'Defence Tech', 'Space', 'Robotics'],
    datasets: [
      {
        data: [100, 150, 120, 80],
        backgroundColor: ['#42A5F5', '#FF7043', '#66BB6A', '#AB47BC'],
      },
    ],
  };

  chartData6 = {
    labels: ['Idex', 'Adiiti', 'Prime', 'OC', 'Fauji'],
    datasets: [
      {
        label: 'Proposal Value',
        data: [200, 150, 180, 100, 120],
        backgroundColor: '#42A5F5',
      },
      {
        label: 'Disbursed Funds',
        data: [150, 120, 160, 90, 100],
        backgroundColor: '#66BB6A',
      },
    ],
  };
  schemeID: any = 46;
  currentRoleName: any;
  // selectedYear: number = new Date().getFullYear();
  yearOptions: any[] = [];
  statusCards: any[] = [];

  // New Dashboard Features Data
  totalContracts: number = 0;
  totalProposals: number = 0;
  totalSubSchemes: number = 0;
  totalPreLaunch: number = 0;
  totalForLaunch: number = 0;
  totalPostLaunch: number = 0;
  completedProposals: number = 0;
  subSchemes: any[] = [];
  schemeWiseApproved: any = {};
  schemeWiseSpent: any = {};
  schemeWisePending: any = {};
  schemeWiseGrant: any = {};
  schemeWiseProposal: any = {};
  schemeWisePrelaunch: any = {};
  schemeWiseForlaunch: any = {};
  schemeWisePostlaunch: any = {};
  schemeWiseCompleted: any = {};
  schemeStatusData: any[] = [];
  totalGrantsApproved: number = 0;
  totalGrantsSpent: number = 0;
  totalGrantsPending: number = 0;
  launchVersionData: any = {
    preLaunch: { proposals: 0, contracts: 0 },
    forLaunch: { proposals: 0, contracts: 0 },
    postLaunch: { proposals: 0, contracts: 0 }
  };
  milestoneData: any[] = [];
  nonContractedProjects: any[] = [];
  rejectedProjects: any[] = [];
  dashboardLoading: boolean = false;

  constructor(
    private messageService: MessageService,
    private api: ApiService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
    this.routeForm = this.fb.group({
      step: [null, Validators.required],
      role: [null, Validators.required],
      user: [null, Validators.required],
      // unit: [null, Validators.required],
      level: [null, Validators.required],
      approved: [false],
    });
  }

  ngOnInit(): void {
    this.switchRole('doi');
    this.challengeForm = this.fb.group({
      organisation: ['', Validators.required],
      category: [''],
      priority: [''],
      challenge_status: [''],
      ip_status: [''],
      releaseDate: ['', Validators.required],
      approvedBy: [''],
      coordinatingAgency: ['', Validators.required],
      technologyDomain: ['', Validators.required],

      challengeTitle: ['', Validators.required],
      nodalOfficer: ['', Validators.required],
      problemStatement: ['', Validators.required],
      challengeBrief: ['', Validators.required],
      prototypeDevelopment: ['', Validators.required],
      requirement: ['', Validators.required],
      ipValue: [''],
      functionalAdvantages: ['', Validators.required],
      domestic: ['', Validators.required],
      substitution: ['', Validators.required],
      preliminaryScope: ['', Validators.required],
      competitiveSolution: ['', Validators.required],
      potentialMarket: ['', Validators.required],
      riskAssessment: ['', Validators.required],
      mpoQty: ['', Validators.required],
    });
    this.route.queryParams.subscribe((params) => {
      const schemeId = params['scheme_id'];
      this.schemeID = schemeId || 46;
      this.getDashboardData(this.selectedYear);
    });
    const currentYear = new Date().getFullYear();
    this.yearOptions = Array.from({ length: 6 }, (_, i) => ({
      label: (currentYear - i).toString(),
      value: currentYear - i,
    }));
    if (this.schemeID) {
    }
    this.gettableData();
    // this.getSchemes();
    this.getProposal('pending');
    this.loadNewDashboardData();
    this.getDashboardData(this.selectedYear);
  }

  loadNewDashboardData() {
    this.dashboardLoading = true;
    // Load all new dashboard features data
    this.getSummaryMetrics();
    // this.getSubSchemes();
    // this.getSchemeStatusBreakdown();
    this.getGrantSummary();
    // this.getLaunchVersionData();
    this.getMilestoneData();
    // this.getNonContractedRejectedProjects();
  }

  getSummaryMetrics() {
    this.api.getAPI(`/idex/dashboard/summary/?scheme_id=${this.schemeID}`).subscribe({
      next: (res: any) => {
        // Map API response to component properties
        this.totalContracts = res.hasOwnProperty('total_grant') ? Number(res.total_grant) : 0;
        this.totalProposals = res.hasOwnProperty('total_proposal') ? Number(res.total_proposal) : 0;
        this.totalPreLaunch = res.hasOwnProperty('total_pre_launch') ? Number(res.total_pre_launch) : 0;
        this.totalForLaunch = res.hasOwnProperty('total_for_launch') ? Number(res.total_for_launch) : 0;
        this.totalPostLaunch = res.hasOwnProperty('total_post_launch') ? Number(res.total_post_launch) : 0;
        this.completedProposals = res.hasOwnProperty('completed_proposal') ? Number(res.completed_proposal) : 0;

        // Store scheme-wise data
        this.schemeWiseGrant = res.scheme_wise_grant || {};
        this.schemeWiseProposal = res.scheme_wise_proposal || {};
        this.schemeWisePrelaunch = res.scheme_wise_prelaunch || {};
        this.schemeWiseForlaunch = res.scheme_wise_forlaunch || {};
        this.schemeWisePostlaunch = res.scheme_wise_postlaunch || {};
        this.schemeWiseCompleted = res.scheme_wise_completed || {};

        console.log('Summary metrics loaded:', res);
      },
      error: (err) => {
        console.error('Error fetching summary metrics:', err);
        // ... error handling
      }
    });
  }

  // getSubSchemes() {
  //   this.api.getAPI(`/idex/dashboard/sub-schemes/?scheme_id=${this.schemeID}`).subscribe({
  //     next: (res: any) => {
  //       this.subSchemes = res.data || res || [];
  //     },
  //     error: () => {
  //       this.subSchemes = [];
  //     }
  //   });
  // }

  // getSchemeStatusBreakdown() {
  //   this.api.getAPI(`/idex/dashboard/scheme-status/?scheme_id=${this.schemeID}&year=${this.selectedYear}`).subscribe({
  //     next: (res: any) => {
  //       this.schemeStatusData = res.data || res || [];
  //     },
  //     error: () => {
  //       this.schemeStatusData = [];
  //     }
  //   });
  // }

  getGrantSummary() {
    this.api.getAPI(`/idex/dashboard/grants/?scheme_id=${this.schemeID}`).subscribe({
      next: (res: any) => {
        this.totalGrantsApproved = res.total_grant_approved || 0;
        this.totalGrantsSpent = res.total_grant_spent || 0;
        this.totalGrantsPending = res.total_grant_pending || 0;

        // Store scheme-wise data
        this.schemeWiseApproved = res.scheme_wise_approved || {};
        this.schemeWiseSpent = res.scheme_wise_spent || {};
        this.schemeWisePending = res.scheme_wise_pending || {};

        console.log('Grant summary loaded:', res);
      },
      error: (err) => {
        console.error('Error fetching grant summary:', err);
        this.totalGrantsApproved = 0;
        this.totalGrantsSpent = 0;
        this.totalGrantsPending = 0;
        this.schemeWiseApproved = {};
        this.schemeWiseSpent = {};
        this.schemeWisePending = {};
      }
    });
  }

  // getLaunchVersionData() {
  //   this.api.getAPI(`/idex/dashboard/launch-versions/?scheme_id=${this.schemeID}`).subscribe({
  //     next: (res: any) => {
  //       this.launchVersionData = {
  //         preLaunch: {
  //           proposals: res.pre_launch?.proposals || 0,
  //           contracts: res.pre_launch?.contracts || 0
  //         },
  //         forLaunch: {
  //           proposals: res.for_launch?.proposals || 0,
  //           contracts: res.for_launch?.contracts || 0
  //         },
  //         postLaunch: {
  //           proposals: res.post_launch?.proposals || 0,
  //           contracts: res.post_launch?.contracts || 0
  //         }
  //       };
  //     },
  //     error: () => {
  //       this.launchVersionData = {
  //         preLaunch: { proposals: 0, contracts: 0 },
  //         forLaunch: { proposals: 0, contracts: 0 },
  //         postLaunch: { proposals: 0, contracts: 0 }
  //       };
  //     }
  //   });
  // }

  getMilestoneData() {
    this.api.getAPI(`/idex/monitoring/module/`).subscribe({
      next: (res: any) => {
        // Map the response similar to monitoring-module
        if (Array.isArray(res)) {
          this.milestoneData = res.map((item, index) => this.mapMilestoneData(item, index));
        } else {
          this.milestoneData = [this.mapMilestoneData(res, 0)];
        }
      },
      error: () => {
        this.milestoneData = [];
      }
    });
  }

  // Map API response to milestone table row format
  mapMilestoneData(response: any, index: number): any {
    const row: any = {
      ser: index + 1,
      challenge: response.challenge?.title || '',
      firmDetails: response.vendor?.company_name
        ? `${response.vendor.company_name} (${response.vendor.phone_number || ''})`
        : '',
    };

    // Map MS 00 to MS 05
    for (let i = 0; i <= 5; i++) {
      const milestone = response.milestones?.[i];
      if (milestone) {
        const disbursedAmount = milestone.disbursed_amount ?? '-';
        const actualDate = milestone.actual_date
          ? new Date(milestone.actual_date).toLocaleDateString('en-GB')
          : '-';
        row[`ms_${i.toString().padStart(2, '0')}`] = `₹${disbursedAmount} | ${actualDate}`;
      } else {
        row[`ms_${i.toString().padStart(2, '0')}`] = '';
      }
    }

    return row;
  }

  // Smart filters removed (per requirement)
  tab: String = "pending"
  getProposal(tab) {
    let url = tab == "pending" ? `/idex/dashboard/challenge/list/` : `/master/proposals/?proposal_status=in_review`;

    this.proposalData = []
    this.api.getAPI(url).subscribe((res: any) => {
      if (tab == 'pending') {
        this.proposalData = res;
      } else {
        this.proposalData = res.data;
      }

    });

  }
  onApprove() {
    let payload = [];
    this.selectedProposals.forEach(proposal => {
      payload.push({
        id: proposal.id,
        proposal_status: 'approved',
      });
    });
    this.api.postAPI(`/idex/dashboard/challenge/list/`, payload).subscribe(res => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Proposals approved successfully',
      });
    });
    this.getProposal('pending');
  }

  // Handle grant card click event
  onGrantCardClick(event: any): void {
    console.log('Grant card clicked:', event);
    // You can add additional logic here if needed
    // Example: Log analytics, show toast notification, etc.

    this.messageService.add({
      severity: 'info',
      summary: 'Grant Details',
      detail: `Viewing ${event.label} breakdown`,
      life: 3000
    });
  }

  navigateToSchemeTransaction(schemeName: any, phaseId: any) {
    console.log(schemeName)
    if (this.tab == 'pending') {
      this.router.navigate(['/idex-aditi-transaction'], {
        queryParams: { id: schemeName.proposal_id, name: schemeName.proposal_name, scheme: schemeName.scheme_id, phase: schemeName.scheme_id, step: schemeName.current_proposal_step }
      });
    } else {
      this.router.navigate(['/idex-aditi-transaction'], {
        queryParams: { id: schemeName.id, name: schemeName.name, scheme: schemeName.scheme.id, phase: phaseId, step: schemeName.step_summary.current_step_id }
      });
    }
  }
  searchQuery: string = '';
  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'approved':
        return 'bg-success';
      case 'pending':
        return 'bg-warning text-dark';
      case 'short_closed':
        return 'bg-secondary';
      case 'rejected':
        return 'bg-danger';
      default:
        return 'bg-info';
    }
  }
  getFieldValue(obj: any, fieldPath: string): any {
    if (!obj || !fieldPath) {
      return null;
    }
    try {
      return fieldPath.split('.').reduce((acc, part) => {
        if (acc && typeof acc === 'object' && part in acc) {
          return acc[part];
        }
        return undefined;
      }, obj);
    } catch {
      return undefined;
    }
  }

  switchRole(role: string) {
    this.currentRole = role;
    this.applyFilters();
  }

  applyFilters() {
    let filtered = [...this.proposals];

    // Step 1: Category filter (from dropdown)
    if (this.filters.category) {
      filtered = filtered.filter((p) => p.category === this.filters.category);
    }


    // Step 3: Priority filter
    if (this.filters.priority) {
      filtered = filtered.filter((p) => p.priority === this.filters.priority);
    }
    if (this.filters.valuation) {
      filtered = filtered.filter((p) => p.valuation === this.filters.valuation);
    }
    // Step 4: Status filter (if needed)
    if (this.filters.status) {
      // filtered = filtered.filter(p => p.status === this.filters.status);
    }

    this.filteredProposals = filtered;
    this.updateStats();
  }

  updateStats() {
    this.stats.total = this.filteredProposals.length;
    // this.stats.pending = this.filteredProposals.filter(p => p.status === 'pending').length;
    // this.stats.screening = this.filteredProposals.filter(p => p.status === 'screening').length;
    // this.stats.approved = this.filteredProposals.filter(p => p.status === 'approved').length;
  }

  updateCategory(id: any, category: string) {
    const p = this.proposals.find((x) => x.id == id);
    if (p) p.category = category;
    this.applyFilters(); // optional: refresh view/stats if you rely on filteredProposals
  }

  updatePriority(id: any, priority: string) {
    // const proposal = this.proposals.find(p => p.id === id);
    // if (proposal) proposal.priority = priority;
  }
  updateValuation(id: any, priority: string) {
    // const proposal = this.proposals.find(p => p.id === id);
    // if (proposal) proposal.priority = priority;
  }
  updatelaunchStatus(id: any, priority: string) { }
  selectedChallengeCount: any[] = [];
  toggleSelectAll() {
    // this.filteredProposals.forEach(p => (p.selected = this.selectAll));
    this.filteredProposals.forEach((proposal) => {
      proposal.selected = this.selectAll;
    });

    if (this.selectAll) {
      this.selectedChallengeCount = [...this.filteredProposals];
    } else {
      this.selectedChallengeCount = [];
    }
  }

  bulkAction(action: string) {
    // const selected = this.filteredProposals.filter(p => p.selected);
    // if (!selected.length) {
    //   alert('Please select at least one proposal.');
    //   return;
    // }
    // alert(`${action.toUpperCase()} applied on: ${selected.map(p => p.id).join(', ')}`);
  }



  closeDetailsModal() {
    this.detailsModalOpen = false;
    this.selectedProposal = null;
  }

  gettableData() {
    let unit = Number(sessionStorage.getItem('unit_id'));
    this.api
      .getAPI(
        `/idex/dashboard/challenge/list/?role_id=${this.userID}&unit_id=${unit}`
      )
      .subscribe({
        next: (res: any[]) => {
          this.proposals = res;
          this.filteredProposals = [...this.proposals];
        },
      });
  }
  onFileSelect(event: any, type: string) {
    const files: File[] = event.files;

    if (type === 'draftSotr') {
      this.draftSotrFile = files[0]; // Only one file expected
    } else if (type === 'supportingDocs') {
      // this.supportingDocsFiles = [...this.supportingDocsFiles, ...files];
      this.supportingDocsFiles = files[0];
    }
  }

  onUploadDraftSotr(event: any) {
    const file: File = event.files[0];
    if (file) {
      this.draftSotrFile = file;
      this.messageService.add({
        severity: 'success',
        summary: 'File attached successfully',
        detail: file.name,
      });
    }
  }

  onUploadSupportingDocs(event: any) {
    // const files: File[] = event.files;
    const file: File = event.files[0];
    if (file) {
      this.supportingDocsFiles = file;
    }
    // this.supportingDocsFiles = [...this.supportingDocsFiles, ...files];
    this.messageService.add({
      severity: 'success',
      summary: 'Supporting Documents Uploaded',
      detail: ` files uploaded`,
    });
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }
  onSubmit() {
    let formData = new FormData();
    console.log(this.challengeForm.value);

    formData.append(
      'organisation',
      this.challengeForm.get('organisation').value
    );
    formData.append('category', this.challengeForm.get('category')?.value);
    formData.append('priority', this.challengeForm.get('priority')?.value);
    formData.append(
      'ip_status',
      this.challengeForm.get('valuation')?.value || ''
    );
    formData.append(
      'challenge_status',
      this.challengeForm.get('challenge_status')?.value || ''
    );
    formData.append(
      'release_date',
      this.challengeForm.get('releaseDate').value
    );
    if (this.challengeForm.get('approvedBy').value != null) {
      formData.append(
        'approved_by',
        this.challengeForm.get('approvedBy').value
      );
    }
    formData.append(
      'coordinated_agency',
      this.challengeForm.get('coordinatingAgency').value
    );
    formData.append(
      'technology_domain',
      this.challengeForm.get('technologyDomain').value
    );

    formData.append('title', this.challengeForm.get('challengeTitle').value);
    formData.append(
      'nodal_officer',
      this.challengeForm.get('nodalOfficer').value
    );
    formData.append(
      'problem_statement',
      this.challengeForm.get('problemStatement').value
    );
    formData.append(
      'challenge_brief',
      this.challengeForm.get('challengeBrief').value
    );
    formData.append(
      'prototype_development',
      this.challengeForm.get('prototypeDevelopment').value
    );
    formData.append('requirement', this.challengeForm.get('requirement').value);
    formData.append('ip_value', this.challengeForm.get('ipValue').value);
    formData.append(
      'functional_advantages',
      this.challengeForm.get('functionalAdvantages').value
    );
    formData.append('domestic', this.challengeForm.get('domestic').value);
    formData.append(
      'substitution',
      this.challengeForm.get('substitution').value
    );
    formData.append(
      'preliminary_scope',
      this.challengeForm.get('preliminaryScope').value
    );
    formData.append(
      'competitive_solution',
      this.challengeForm.get('competitiveSolution').value
    );
    formData.append(
      'potential_market',
      this.challengeForm.get('potentialMarket').value
    );
    formData.append(
      'risk_assessment',
      this.challengeForm.get('riskAssessment').value
    );
    formData.append('mpo_qty', this.challengeForm.get('mpoQty').value);

    if (this.draftSotrFile) {
      formData.append('pds', this.draftSotrFile);
    }

    if (this.supportingDocsFiles) {
      // this.supportingDocsFiles.forEach(file => {
      formData.append('pru', this.supportingDocsFiles); // Change key name if needed
      // });
    }
    // console.log(formData, this.selectedProposal);
    let url = `/idex/challenges/${this.selectedProposal.id}/`;

    const sub = this.api.putAPI(url, formData).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Challenge Updated successfully',
        });
        // ✅ Update the currently open proposal so UI refreshes immediately
        this.selectedProposal = {
          ...this.selectedProposal,
          pds: res.pds || this.selectedProposal.pds,
          pru: res.pru || this.selectedProposal.pru,
        };
        this.gettableData();
        this.fileUpload.clear();
        this.draftSotrUpload.clear();
      },
      error: (err) => { },
    });
    this.subscriptions.add(sub);
  }
  routeModal: boolean = false;
  openRouteModal() {
    // alert('Open route configuration modal here.');
    this.routeModal = true;
    this.selectedChallenges = this.proposals.filter((p) => p.selected);
    if (this.userID != '3') {
      this.getRoleList();
      this.getUserList();
      this.getUnit();
    }

    if (this.selectedChallenges.length > 0) {
      this.routeModal = true;
    }
  }


  onChallengeSelectChange(proposal: any) {
    if (proposal.selected) {
      // Add if not already in list
      if (!this.selectedChallengeCount.some((ch) => ch.id === proposal.id)) {
        this.selectedChallengeCount.push(proposal);
      }
    } else {
      // Remove if unchecked
      this.selectedChallengeCount = this.selectedChallengeCount.filter(
        (ch) => ch.id !== proposal.id
      );
    }
  }

  onrouteFormSubmit() {
    const formValue = this.routeForm.value;
    const currentUserRole = sessionStorage.getItem('user_role_name');
    const selectedUser = this.userList.find((u) => u.id === formValue.user);

    // ✅ Build payload for each selected challenge
    const payload = this.selectedChallenges.map((challenge, index) => ({
      proposal_step:
        currentUserRole?.toLowerCase() === 'approver'
          ? challenge.next_proposal_step_id
          : challenge.current_proposal_step,
      role: formValue.role,
      user: formValue.user,
      sequence: formValue.level,
      unit: selectedUser ? selectedUser.unit?.id : null,
      is_final_approve: formValue.approved === true,
    }));

    console.log('Payload:', payload); // 🔍 Debug
    const sub = this.api
      .postAPI(`/idex/bulk/proposal-workflow/`, payload)
      .subscribe({
        next: (res: any) => {
          this.routeForm.reset();
          this.selectedChallenges = null;
          this.routeModal = false;
          this.gettableData();
        },
        error: (err) => {
          console.error('Update failed:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail:
              err?.error?.detail ||
              'Something went wrong while updating the mapping.',
          });
        },
      });
    this.subscriptions.add(sub);
  }
  submitIRA() {
    let role_id = sessionStorage.getItem('user_role_id');
    const payload = this.selectedChallenges.map((challenge, index) => ({
      proposal_step: challenge.current_proposal_step,
      role_id: Number(role_id),
      is_approved: true,
      remark: this.IRAremarks,
    }));
    console.log('ira', payload);
    this.IRAremarks = '';
    const sub = this.api
      .postAPI(`/idex/bulk/proposal-ira-action/`, payload)
      .subscribe((res: any) => {
        this.isEditable = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'sent successfully',
        });
        if (this.userID != '3') {
          this.onrouteFormSubmit();
        } else {
          this.routeModal = false;
          this.gettableData();
        }
      });
    this.subscriptions.add(sub);
  }
  getRoleList() {
    const currentUserRole = sessionStorage.getItem('user_role_name'); // e.g. "initiator", "rec", "approver"

    const rolePriority = ['INT', 'REC', 'APP']; // desired order

    this.api.getAPI('/access/user-roles/').subscribe((res: any) => {
      const resp = res.data;

      // Base filter: only roles that exist in priority
      let roles = resp.filter((role) => rolePriority.includes(role.code));

      // Apply visibility rules
      if (
        currentUserRole?.toLowerCase() === 'initiator' &&
        this.filteredProposals[0].proposal_step_status == '0' &&
        this.filteredProposals[0].type == 'formulation challenge'
      ) {
        roles = roles.filter((r) => r.code === 'APP');
      } else if (
        currentUserRole?.toLowerCase() === 'initiator' &&
        this.filteredProposals[0].proposal_step_status == '0' &&
        this.filteredProposals[0].type == 'initiation challenge'
      ) {
        roles = roles.filter((r) => r.code === 'REC' || r.code === 'APP');
      } else if (
        currentUserRole?.toLowerCase() === 'initiator' &&
        this.filteredProposals[0].proposal_step_status == '0' &&
        this.filteredProposals[0].type == 'challenge approval'
      ) {
        roles = roles.filter((r) => r.code === 'APP');
      } else if (currentUserRole?.toLowerCase() === 'rec') {
        roles = roles.filter((r) => r.code === 'REC' || r.code === 'APP');
      } else if (currentUserRole?.toLowerCase() === 'approver') {
        roles = roles.filter((r) => r.code === 'INT');
      }

      // Sort roles in defined priority order
      this.roleList = roles.sort(
        (a, b) => rolePriority.indexOf(a.code) - rolePriority.indexOf(b.code)
      );
    });
  }

  getUserList() {
    const sub = this.api.getAPI('/account/users/').subscribe((res: any) => {
      this.userList = res.data;
      this.userListCopy = [...this.userList];
    });
    this.subscriptions.add(sub);
  }
  getUnit() {
    const sub = this.api.getAPI('/master/units/').subscribe((res: any) => {
      this.unitList = res.data;
    });
    this.subscriptions.add(sub);
  }
  onRoleChange(event: any) {
    // this.roleID = event.value;
    this.tryFetchingSequence();
  }

  onUserChange(event: any) {
    // this.userID = event.value;
    this.tryFetchingSequence();
  }
  onUnitChange(event: any) {
    let unit_id = event.value;
    this.userList = this.userListCopy.filter(
      (user) => user.unit?.id == unit_id
    );
  }
  tryFetchingSequence() {
    const step = this.selectedChallenges[0].current_proposal_step;
    const role = this.routeForm.get('role').value;
    const user = this.routeForm.get('user').value;
    if (step && role && user) {
      this.getSequence();
    }
  }

  getSequence() {
    const step = this.selectedChallenges[0].current_proposal_step;
    const role = this.routeForm.get('role').value;
    const user = this.routeForm.get('user').value;
    const sub = this.api
      .getAPI(
        `/transaction/get-next-level/?proposal_step_id=${step}&role_id=${role}`
      )
      .subscribe((res: any) => {
        const sequenceValue = res.level ?? '';
        this.routeForm.get('level')?.patchValue(sequenceValue);
      });
    this.subscriptions.add(sub);
  }

  activeTab: string = 'upload';
  selectedProposals: any[] = [];
  showReviewModal: boolean = false;
  showActionModal: boolean = false;

  milestoneproposals = [
    {
      id: 'PROP001',
      title: 'AI Research Initiative',
      status: 'Active',
      milestones: 5,
      progress: 60,
      nextDeadline: '2024-10-15',
    },
    {
      id: 'PROP002',
      title: 'Defense Technology Project',
      status: 'Active',
      milestones: 8,
      progress: 25,
      nextDeadline: '2024-09-20',
    },
    {
      id: 'PROP003',
      title: 'Cyber Security Enhancement',
      status: 'Review',
      milestones: 6,
      progress: 80,
      nextDeadline: '2024-09-30',
    },
  ];

  wbsVersions = [
    {
      version: 'v1.0',
      uploadDate: '2024-08-15',
      status: 'Active',
      uploader: 'John Doe',
    },
    {
      version: 'v1.1',
      uploadDate: '2024-08-25',
      status: 'Draft',
      uploader: 'Jane Smith',
    },
  ];

  tranchePayments = [
    {
      milestone: 'Milestone 1',
      percentage: 20,
      amount: 100000,
      dueDate: '2024-09-15',
      status: 'Completed',
    },
    {
      milestone: 'Milestone 2',
      percentage: 30,
      amount: 150000,
      dueDate: '2024-10-15',
      status: 'Pending',
    },
    {
      milestone: 'Milestone 3',
      percentage: 25,
      amount: 125000,
      dueDate: '2024-11-15',
      status: 'Upcoming',
    },
  ];

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  toggleProposalSelection(id: string, checked: boolean) {
    if (checked) {
      this.selectedProposals.push(id);
    } else {
      this.selectedProposals = this.selectedProposals.filter((p) => p !== id);
    }
  }
  proposalSteps: { id: number; nextStep: number }[] = [];

  addProposalStep(proposal: any) {
    this.proposalSteps.push({
      id: proposal.id,
      nextStep: proposal.next_proposal_step_id,
    });
  }
  openFullscreen(chartId: string) {
    const chartsMap: any = {
      chart1: { type: 'bar', data: this.chartData1 },
      chart2: { type: 'bar', data: this.chartData2 },
      chart3: { type: 'line', data: this.chartData3 },
      chart4: { type: 'pie', data: this.chartData4 },
      chart5: { type: 'doughnut', data: this.chartData5 },
      chart6: { type: 'bar', data: this.chartData6 },
    };
    this.fullscreenChart = chartsMap[chartId];
    this.fullscreenVisible = true;
  }
  navigateto() {
    this.router.navigate(['/scheme/idex'], {
      queryParams: { scheme_id: this.schemeID },
    });
  }
  onYearChange() {
    this.getDashboardData(this.selectedYear);
  }

  onFilterChange() {

    if (this.fromDate && this.toDate) {
      this.getDashboardData(this.selectedYear);
    }

  }

  getDashboardData(year: number) {

    this.api
      .getAPI(`/idex/dashboard/details/?scheme_id=${this.schemeID}&year=${year}`)
      .subscribe({
        next: (res: any) => {

          const data = res.yearly_received_vs_completed || {};

          this.years = Object.keys(data).map(Number);

          this.yearlyData = data[year] || [];

          // labels (scheme names)
          const labels = this.yearlyData.map((d: any) =>
            d.scheme_name.length > 25
              ? d.scheme_name.substring(0, 25) + '...'
              : d.scheme_name
          );

          const keys = Object.keys(this.yearlyData[0] || {}).filter(
            key =>
              key !== 'scheme_name' &&
              key !== 'id' &&
              key !== 'scheme_id'
          );
          const colors: any = {
            received: '#3B82F6',
            approved: '#22C55E',
            rejected: '#EF4444',
            short_close: '#F59E0B',
            project_bank: '#8B5CF6'
          };

          const numSeries = Math.max(keys.length, 1);
          const numCategories = Math.max(labels.length, 1);
          // Per Y category: allocate just enough height for grouped bars.
          // Keep tight to avoid blank space at bottom.
          const perCategoryPx = Math.max(44, numSeries * 16 + 16);
          const legendReserve = 44; // compact legend at top
          this.proposalTrendsChartHeightPx = Math.min(
            780,
            Math.max(300, numCategories * perCategoryPx + legendReserve)
          );

          const datasets = keys.map((key: any) => ({
            label: key.replace('_', ' ').toUpperCase(),
            backgroundColor: colors[key] || '#64748B',
            data: this.yearlyData.map((d: any) => d[key]),
            maxBarThickness: Math.min(22, Math.max(10, Math.floor(perCategoryPx / (numSeries + 2))))
          }));

          this.chartData1 = {
            labels: labels,
            datasets: datasets
          };



          this.chartOptions = {

            responsive: true,
            maintainAspectRatio: false,

            indexAxis: 'y',

            datasets: {
              bar: {
                categoryPercentage: 0.92,
                barPercentage: 0.88
              }
            },

            layout: {
              padding: { top: 6, bottom: 6, left: 4, right: 8 }
            },

            plugins: {
              legend: {
                position: 'top',
                align: 'center',
                labels: {
                  boxWidth: 10,
                  boxHeight: 10,
                  padding: 8,
                  font: { size: 10 }
                }
              },
              tooltip: {
                callbacks: {
                  title: (items: any) => {
                    const index = items[0].dataIndex;
                    return this.yearlyData[index].scheme_name;
                  }
                }
              }
            },

            scales: {

              x: {
                beginAtZero: true,
                ticks: {
                  precision: 0
                }
              },

              y: {
                ticks: {
                  autoSkip: false,
                  font: { size: 11 }
                },
                grid: {
                  display: false
                }
              }

            }

          };

        }
      });

  }



  // Handle summary card click event
  onSummaryCardClick(event: any): void {
    console.log('Summary card clicked:', event);

    this.messageService.add({
      severity: 'info',
      summary: 'Details View',
      detail: `Viewing ${event.label} breakdown`,
      life: 3000
    });
  }
  // async exportData() {
  //   const pdf = new jsPDF('p', 'mm', 'a4');
  //   const chartElements = document.querySelectorAll('.chart-card');

  //   let position = 10;

  //   for (let i = 0; i < chartElements.length; i++) {
  //     const element = chartElements[i] as HTMLElement;

  //     // Convert chart to canvas
  //     const canvas = await html2canvas(element, { scale: 2 });

  //     const imgData = canvas.toDataURL('image/png');
  //     const imgWidth = 180; // Width in mm for A4
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //     if (i > 0) {
  //       pdf.addPage();
  //       position = 10; // Reset position on new page
  //     }

  //     pdf.addImage(imgData, 'PNG', 15, position, imgWidth, imgHeight);
  //   }

  //   pdf.save('proposal-charts.pdf');
  // }
}

export interface Proposal {
  [x: string]: any;
  id: number;
  isInitiator: boolean;
  isRecommender: boolean;
  isApprover: boolean;
  proposal_name: string;
  code: string;
  status: number;
  organisation: string;
  category: string;
  releaseDate: string | null;
  coordinated_agency: string;
  technology_domain: string;
  title: string;
  nodal_officer: string;
  problem_statement: string;
  challenge_brief: string;
  prototype_development: string;
  requirement: string;
  functional_advantages: string;
  domestic: string;
  substitution: string;
  preliminary_scope: string;
  competitive_solution: string;
  potential_market: string;
  risk_assessment: string;
  mpo_qty: string;
  ip_value: string | null;
  pds: string | null;
  pru: string | null;
  priority: string | null;
  proposalStep: number;
  created_on: string;
  modifiedOn: string;
  createdBy: number;
  modifiedBy: number;
  approved_by: number | null;
  selected?: any;
  release_date?: string;
  proposal_step?: any;
  next_proposal_step_id?: any;
  valuation?: string;
  launchStatus?: string;
  challenge_status?: string;
  ip_status?: string;
  current_proposal_step?: number;
  type?: string;
  proposal_step_status?: string;
}
